import { render, staticRenderFns } from "./ManageLegalRole.vue?vue&type=template&id=4f8e3fd4&"
import script from "./ManageLegalRole.vue?vue&type=script&lang=js&"
export * from "./ManageLegalRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports